export enum CampaignType {
  All = '0',
  Newsletter = '1',
  SMS = '2',
  Whatsapp = '3'
}

export const M_AllCampaignChannelds = [
  CampaignType.All,
  CampaignType.Newsletter,
  CampaignType.SMS,
  CampaignType.Whatsapp
]